import { render } from "./PuzzleListView.vue?vue&type=template&id=4123e908&scoped=true"
import script from "./PuzzleListView.vue?vue&type=script&lang=js"
export * from "./PuzzleListView.vue?vue&type=script&lang=js"

import "./PuzzleListView.vue?vue&type=style&index=0&id=4123e908&scoped=true&lang=css"

import exportComponent from "/Users/yangyu/go/go-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4123e908"]])

export default __exports__